/* Código da mensagem ("(Ref.: ERR-SC-008)") que o backend acrescenta e o suporte
   usa para achar o caso. Telas que traduzem a mensagem do backend trocam o texto;
   estas funções garantem que o código continue no fim. */

const REFERENCE_PATTERN = /\s*\(Ref\.:\s*([^)]+)\)\s*$/;
const MESSAGE_FIELDS = ['mensagem', 'message', 'error'];
// Código do dicionário (ERR-MÓDULO-SEQ) no início da referência: "ERR-SC-095 · 4bf92f35…"
const ERROR_CODE_PATTERN = /^ERR-[A-Z]+-\d+/;

/** "(Ref.: X)" do fim do texto, ou null. */
export function extractReference(text) {
  const match = typeof text === 'string' ? text.match(REFERENCE_PATTERN) : null;

  return match ? match[1].trim() : null;
}

/** Texto sem o "(Ref.: X)" e sem o ponto que o antecede — para comparar com chaves. */
export function stripReference(text) {
  if (typeof text !== 'string') return text;

  return text.replace(REFERENCE_PATTERN, '').replace(/\.$/, '').trim();
}

function _codesOfMessages(data) {
  return MESSAGE_FIELDS.map((field) => extractReference(data?.[field])?.match(ERROR_CODE_PATTERN)?.[0]).filter(Boolean);
}

/** Código do dicionário da resposta de erro: o errorCode ou o do "(Ref.: …)"; sem código, null. */
export function errorCodeOf(error) {
  const data = error?.response?.data;

  return data?.errorCode || _codesOfMessages(data)[0] || null;
}

/** A resposta de erro traz este código: no errorCode ou no "(Ref.: X)" da mensagem. */
export function hasErrorCode(error, code) {
  if (!code) return false;

  const data = error?.response?.data;

  return data?.errorCode === code || _codesOfMessages(data).includes(code);
}

function _referenceFromError(error) {
  const data = error?.response?.data;
  const fromMessage = MESSAGE_FIELDS.map((field) => extractReference(data?.[field])).find(Boolean);

  if (fromMessage) return fromMessage;

  if (data?.errorCode) return data.errorCode;

  return error?.response?.status ? `HTTP-${error.response.status}` : extractReference(typeof error === 'string' ? error : error?.message);
}

/** Texto traduzido pela tela + o código da resposta original, quando houver. */
export function withMessageReference(text, error) {
  if (typeof text !== 'string' || !text.trim() || extractReference(text)) return text;

  const reference = _referenceFromError(error);

  return reference ? `${text.trim().replace(/\.$/, '')}. (Ref.: ${reference})` : text;
}
